import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { fmtNZD } from "@/lib/api";

export default function PublicVariationApproval() {
  const { token } = useParams();
  const [v, setV] = useState(null);
  const [name, setName] = useState(""); const [comment, setComment] = useState("");
  const [err, setErr] = useState(""); const [done, setDone] = useState(null);

  useEffect(() => {
    api.get(`/public/variations/${token}`).then(r => setV(r.data)).catch(() => setErr("Link invalid or expired"));
  }, [token]);

  async function decide(decision) {
    setErr("");
    if (decision === "Approved" && !name.trim()) { setErr("Please enter your full name to approve"); return; }
    try {
      await api.post(`/public/variations/${token}/decide`, { decision, name, comment });
      setDone(decision);
    } catch (e) { setErr(e?.response?.data?.detail || "Failed"); }
  }

  if (err && !v) return <div className="min-h-screen bg-black text-white p-6">{err}</div>;
  if (!v) return <div className="min-h-screen bg-black text-white p-6">Loading…</div>;
  if (done) return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="max-w-xl mx-auto card">
        <h1 className="text-silver text-2xl mb-2">Thank you</h1>
        <p>Your decision — <b>{done}</b> — has been recorded.</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="max-w-xl mx-auto card space-y-3">
        <div className="font-bold tracking-widest text-silver border border-silver px-3 py-1 inline-block">LW&amp;Co Hub</div>
        <h1 className="text-2xl">Variation {v.number}</h1>
        <p className="opacity-80">{v.description}</p>
        <div className="text-silver">Reason: {v.reason}</div>
        <div className="text-xl">Amount ex GST: {fmtNZD(v.amount_ex)}</div>
        <div className="opacity-80">Total inc GST: {fmtNZD(v.amount_inc)}</div>
        <div className="opacity-80">Time impact: {v.time_impact_days} working days</div>
        <input className="input" placeholder="Your full name (required to approve)" value={name} onChange={e=>setName(e.target.value)} data-testid="pub-name"/>
        <textarea className="input" rows={3} placeholder="Comment (optional)" value={comment} onChange={e=>setComment(e.target.value)}/>
        {err && <div className="text-red-500 text-sm">{err}</div>}
        <div className="flex gap-2">
          <button className="btn-silver" onClick={()=>decide("Approved")} data-testid="pub-approve">Approve</button>
          <button className="btn-ghost" onClick={()=>decide("Rejected")}>Reject</button>
        </div>
      </div>
    </div>
  );
}
